<button 
    [type]="htmlType"
    [ngClass]="[
        classNameSuffix == 'primary-green' ? '_button-primary-green' : '',
        classNameSuffix == 'primary' ? '_button-primary' : '',
        classNameSuffix == 'primary-dark' ? '_button-primary-dark' : '',
        classNameSuffix == 'secondary' ? '_button-secondary' : '',
        classNameSuffix == 'base' ? '_button-primary' : '',
        modifierClassNames ? modifierClassNames : ''
    ]"
    [disabled]="disabled || loading"
    (click)="onClick ? onClick() : null"
    (blur)="onBlur ? onBlur() : null">
    <span
        class="_flex _flex-nowrap" 
        [ngClass]="{ '_invisible' : loading}" >
        <ng-content></ng-content>
    </span>
    <ng-container *ngIf="loading">
        <i class="fas fa-circle-notch fa-spin _absolute _center-xy"></i>
    </ng-container> 
</button>
